<template>
    <div>
        <draggable
            v-model="data"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                class="faq-item relative bg-white p-4 my-4 rounded-lg cursor-pointer max-w-5xl shadow-sm"
                v-for="(datum, index) in data"
                :key="`faq-${index}`"
            >
                <div class="absolute top-4 right-4 z-10">
                    <div class="flex">
                        <button @click="() => handleDelete(index)">
                            <svg
                                v-if="data.length > 1"
                                class="w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                        </button>
                        <div class="pl-1 handle" title="Drag to reorder items">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div>
                    <input-text
                        label="* Question"
                        :name="`question_and_answers[${index}][question]`"
                        v-model="datum.question"
                    />
                    <error
                        :error="
                        errorBag[`question_and_answers.${index}.question`]
                            ? errorBag[
                                  `question_and_answers.${index}.question`
                              ][0]
                            : null
                    "
                    />
                </div>

                <input-rich-text
                    label="* Answer"
                    :name="`question_and_answers[${index}][answer]`"
                    :language="language"
                    v-model="datum.answer"
                    editor="content"
                    :error="
                        errorBag[`question_and_answers.${index}.answer`]
                            ? errorBag[
                                  `question_and_answers.${index}.answer`
                              ][0]
                            : null
                    "
                ></input-rich-text>
            </div>
            <button
                class="mt-2 text-indigo-600 hover:text-indigo-900"
                @click="AddItem"
            >
                + Add FAQ
            </button>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage'
import {useFroalaStore} from "../../stores/froala";

export default {
    components: { draggable },
    name: "FaqInput",
    props: {
        value: Array,
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            data: this.value
                ? this.value
                : [
                      {
                          question: "",
                          answer: "",
                      },
                  ],
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        AddItem(e) {
            e.preventDefault();
            this.data.push({
                question: "",
                answer: "",
            });
        },
        handleDelete: function (indexOfItemToDelete) {
            this.data = this.data.splice(indexOfItemToDelete, 1);
        },
    },
    watch: {
        value(newValue) {
            if (!newValue) return;
            this.data = newValue;
        },
    },
};
</script>
